import styled from "@emotion/styled";
export const TextAreaStyled = styled.textarea`
  background-color: #f8f8f8;
  border: solid #a2a2a2 1px;
  resize: none;
  margin-top: 2em;
  font-family: Poppins ExtraLight;
  width: 50%;
  height: 6em;
  text-align: center;
  border-radius: 0.3em;
`;
